'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { isShopPathname } from '@/lib/utils/loginPath';
import { hideStoreLoadingCover } from './hideStoreLoadingCover';

/**
 * The cover is emitted by the root layout, so a soft navigation away from
 * /shop before the shop is ready would leave the fixed overlay stuck on the
 * next route (StoreLoadingCoverDismiss unmounts with the page and its timers
 * are cleared). This guard lives next to the cover in the layout and hides it
 * the moment the pathname is no longer a shop route.
 */
export function StoreLoadingCoverGuard() {
    const pathname = usePathname();

    useEffect(() => {
        if (!isShopPathname(pathname)) {
            // No paint/font waits: a fixed overlay lingering over another
            // route is worse than a layout shift nobody is looking at.
            hideStoreLoadingCover({ immediate: true });
        }
    }, [pathname]);

    return null;
}
